import { GeoPoint, Timestamp } from 'firebase/firestore'
import { z } from 'zod'

export const TransportRequestZod = z.object({
  status: z.enum([
    'allocated',
    'assigned',
    'cancelled',
    'completed',
    'deleted_draft',
    'error',
    'on_board',
    'pending',
    'submitted',
    'transferred',
    'unfindable',
  ]),
  type: z.enum(['pilote', 'mobile']),
  regionId: z.string(),
  piloteId: z.number(),
  team: z
    .object({
      id: z.string(),
    })
    .optional(),
  donation: z
    .object({
      status: z.enum(['NOT_STARTED', 'SMS_SENT', 'SMS_LINK_CLICKED', 'COMPLETE']),
      value: z.number(),
    })
    .optional(),
  customerFirstName: z.string(),
  customerLastName: z.string(),
  customerPhoneNumber: z.string(),
  numberOfPassengers: z.number(),
  customerVehicle: z.object({
    manufacturer: z.string(),
    model: z.string(),
    color: z.number(),
    seats: z.number(),
    manualTransmission: z.boolean(),
  }),
  origin: z.object({
    geolocation: z
      .instanceof(GeoPoint)
      .transform((v) => ({ lat: v.latitude, lng: v.longitude }))
      .readonly(),
    formattedAddress: z.string(),
  }),
  destination: z.object({
    geolocation: z
      .instanceof(GeoPoint)
      .transform((v) => ({ lat: v.latitude, lng: v.longitude }))
      .readonly(),
    formattedAddress: z.string(),
  }),
  submitTimestamp: z.instanceof(Timestamp).transform((v) => v.toDate()),
  assignmentTimestamp: z
    .instanceof(Timestamp)
    .transform((v) => v.toDate())
    .optional(),
  allocationTimestamp: z
    .instanceof(Timestamp)
    .transform((v) => v.toDate())
    .optional(),
  onboardTimestamp: z
    .instanceof(Timestamp)
    .transform((v) => v.toDate())
    .optional(),
  completionTimestamp: z
    .instanceof(Timestamp)
    .transform((v) => v.toDate())
    .optional(),
  evaluatedDistance: z
    .object({
      durationInSeconds: z.number(),
      distanceInMeters: z.number(),
    })
    .optional(),
  assignedBy: z.number().nullable().optional(),
  availableForAutomation: z.boolean().optional(),
  plannedTeamAssignment: z
    .object({
      teamId: z.string().nullable(),
      planId: z.string(),
      willExecuteAt: z
        .instanceof(Timestamp)
        .transform((v) => v.toDate())
        .optional(),
    })
    .optional(),

  dashboardPendingRequest: z
    .object({
      type: z.string(),
      timestamp: z.instanceof(Timestamp).transform((v) => v.toDate()),
      payload: z.record(z.string(), z.unknown()).optional(),
    })
    .optional(),
  internalNote: z.string().nullish().default(''),
  cancellationReason: z.enum(['teamArrivingTooEarly', 'teamArrivingTooLate', 'foundOtherSolution', 'other']).optional(),
})
